<template>
    <w-card class="mb3">
        <div class="dashboard-title mb3">
            PERBANDINGAN KUTIPAN BULAN {{ bulanLong }} BAGI TAHUN {{ year }} ,
            {{ year - 1 }} DAN {{ year - 2 }}
        </div>
        <w-spinner fade v-if="loadingPTJ"></w-spinner>
        <table v-else style="width: 100%" class="mb2 table-dashboard">
            <thead>
                <tr class="text-center">
                    <td class="">TAHUN</td>
                    <td class="" colspan="3">{{ bulanLong }} {{ year }}</td>
                    <td class="" colspan="3">{{ bulanLong }} {{ year - 1 }}</td>
                    <td class=" " colspan="3">
                        {{ bulanLong }} {{ year - 2 }}
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row-data">
                    <td></td>
                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>

                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>

                    <td style="background: rgba(247, 110, 17, 0.6)">
                        ANGGARAN (RM)
                    </td>
                    <td style="background: rgba(255, 159, 69, 0.6)">
                        KUTIPAN (RM)
                    </td>
                    <td style="background: rgba(166, 75, 42, 0.6)">%</td>
                </tr>

                <tr class="table-row-data" v-for="items in tablePTJ.rows">
                    <template v-for="item in items">
                        <td class="ptj-table-data">{{ item }}</td>
                    </template>
                </tr>
            </tbody>
        </table>
    </w-card>

    <w-flex class="mb3" :gap=3>
        <w-card class="xs6">
            <w-spinner fade v-if="loadingPTJ"></w-spinner>
            <fusioncharts
                v-else
                :type="chart9.type"
                :width="chart9.width"
                :height="chart9.height"
                :dataformat="chart9.dataFormat"
                :dataSource="chart9.dataSource"
            >
            </fusioncharts>
        </w-card>
        <w-card class="xs6">
            <w-spinner fade v-if="loadingPTJ"></w-spinner>
            <fusioncharts
                v-else
                :type="chart10.type"
                :width="chart10.width"
                :height="chart10.height"
                :dataformat="chart10.dataFormat"
                :dataSource="chart10.dataSource"
            >
            </fusioncharts>
        </w-card>
    </w-flex>

    <w-flex class="mb3" :gap=3>
        <w-card class="xs6">
            <w-spinner fade v-if="loadingPTJ"></w-spinner>
            <fusioncharts
                v-else
                :type="chart11.type"
                :width="chart11.width"
                :height="chart11.height"
                :dataformat="chart11.dataFormat"
                :dataSource="chart11.dataSource"
            >
            </fusioncharts>
        </w-card>
        <w-card class="xs6">
            <w-spinner fade v-if="loadingPTJ"></w-spinner>
            <fusioncharts
                v-else
                :type="chart12.type"
                :width="chart12.width"
                :height="chart12.height"
                :dataformat="chart12.dataFormat"
                :dataSource="chart12.dataSource"
            >
            </fusioncharts>
        </w-card>
    </w-flex>
</template>
<script>

export default {
    props: {
        isActive: false
    },
    data(){
        return {
            loadingPTJ: true,
            bulan: new Intl.DateTimeFormat('ms-MY', { month: 'numeric'}).format(new Date()),
            bulanLong: new Intl.DateTimeFormat('ms-MY', { month: 'long'}).format(new Date()),
            year: new Intl.DateTimeFormat('ms-MY', { year: 'numeric'}).format(new Date()),
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            tablePTJ: {
                columns: [],
                rows: [],
            },
            chart9: {
                type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        theme: "fusion",
                        caption: "JUMLAH HASIL TANAH",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        sNumberSuffix: "%",
                    },
                    categories: [],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {value: 0},
                                {value: 0},
                                {value: 0},
                            ],
                        },
                    ],
                },
            },
            chart10: {
                type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        theme: "fusion",
                        caption: "JUMLAH HASIL DAERAH",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        sNumberSuffix: "%",
                    },
                    categories: [],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {value: 0},
                                {value: 0},
                                {value: 0},
                            ],
                        },
                    ],
                },
            },
            chart11: {
                type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        theme: "fusion",
                        caption: "JUMLAH HASIL HUTAN",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        sNumberSuffix: "%",
                    },
                    categories: [],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {value: 0},
                                {value: 0},
                                {value: 0},
                            ],
                        },
                    ],
                },
            },
            chart12: {
                type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        theme: "fusion",
                        caption: "JUMLAH HASIL PELBAGAI",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        sNumberSuffix: "%",
                    },
                    categories: [],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: 0 },
                                { value: 0 },
                                { value: 0 },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {value: 0},
                                {value: 0},
                                {value: 0},
                            ],
                        },
                    ],
                },
            },
        }
    },
    methods: {
        async fetchData(){
            await axios
                .get(`${this.apiBaseUrl}/dashboard/ptj`)
                .then((resp) => {                   
                    this.tablePTJ = resp.data.table
                    console.log(this.tablePTJ)
                    const categories = [
                        {
                            category: [
                                {
                                    label: `${this.bulanLong} ${this.year}`,
                                },
                                {
                                    label: `${this.bulanLong} ${this.year}`,
                                },
                                {
                                    label: `${this.bulanLong} ${this.year}`,
                                },
                            ],
                        },
                    ];
                    
                    this.chart9.dataSource.categories = categories;
                    this.chart10.dataSource.categories = categories;
                    this.chart11.dataSource.categories = categories;
                    this.chart12.dataSource.categories = categories;
                    
                    this.chart9.dataSource.dataset[1].data = resp.data.barChart.kutipan.tanah
                    this.chart10.dataSource.dataset[1].data = resp.data.barChart.kutipan.daerah
                    this.chart11.dataSource.dataset[1].data = resp.data.barChart.kutipan.hutan
                    this.chart12.dataSource.dataset[1].data = resp.data.barChart.kutipan.pelbagai
                })
                .catch((err) => {
                    console.error(err);
                });
            this.rerender();
        },
        async rerender(){
            this.loadingPTJ = true;
            await this.$nextTick();
            this.loadingPTJ = false;
        }
    },
    mounted(){
        this.fetchData()
    },
    watch: {
        isActive(nv, ov) {
            if (nv) {
                this.rerender();
            }
        }
    },
}
</script>
